import ReactDOM from 'react-dom/client';

import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import './index.scss';

import App from './App';
import CustomerMaterials from './pages/CustomerMaterials';
import Palettes from './pages/Palettes';
import FinishDetails from './pages/FinishDetails';
import SearchResults from './pages/SearchResults';
import SpecSheet from './pages/SpecSheet';
import FabricCategoryPage from './pages/CategoryPages/FabricCategoryPage';
import LaminateCategoryPage from './pages/CategoryPages/LaminateCategoryPage';
import PaintCategoryPage from './pages/CategoryPages/LaminateCategoryPage';
import OthersCategoryPage from './pages/CategoryPages/OthersCategoryPage';
import PaletteDetailsPage from './pages/PaletteDetailsPage';
import NotFound from './pages/NotFound';
import { algoliaConfig } from './data/config';
import Overview from './pages/Overview';
import { getCategoryPage } from './utils/utils';
import MaterialDrawer from './pages/MaterialDrawer';

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    //errorElement: <ErrorPage />,
    children: [
      {
        path: "/finishlibrary",
        element: <Overview />
      },
      {
        path: "/finishes/fabric",
        element: <FabricCategoryPage indexName={algoliaConfig.MATERIAL_INDEX} categoryPage={getCategoryPage("fabric")} />
      },
      {
        path: "/finishes/laminate-wood",
        element: <LaminateCategoryPage indexName={algoliaConfig.MATERIAL_INDEX} categoryPage={getCategoryPage("laminate_wood")} />
      },
      {
        path: "/finishes/paint",
        element: <PaintCategoryPage indexName={algoliaConfig.MATERIAL_INDEX} categoryPage={getCategoryPage("paint")} />
      },
      {
        path: "/finishes/more-surfaces",
        element: <OthersCategoryPage indexName={algoliaConfig.MATERIAL_INDEX} categoryPage={getCategoryPage("more_surfaces")} />
      },
      {
        path: "/palettes",
        element: <Palettes />
      },
      {
        path: "/customer-materials",
        element: <CustomerMaterials indexName={algoliaConfig.MATERIAL_INDEX} />
      },
      {
        path: "/finish/:finish_code",
        element: <FinishDetails />
      },
      {
        path: "/finish/:finish_code/spec_sheet",
        element: <SpecSheet />
      },
      {
        path: "/finishes/search",
        element: <SearchResults indexName={algoliaConfig.MATERIAL_INDEX}/>
      },
      {
        path: "/palettes/:palette_id",
        element: <PaletteDetailsPage />
      },
      {
        path: "/finish/not-found",
        element: <NotFound />
      },
      {
        path: "/products/:category/:product",
        element: <MaterialDrawer indexName={algoliaConfig.MATERIAL_INDEX} />
      },
      {
        path: "/produkte/:category/:product",
        element: <MaterialDrawer indexName={algoliaConfig.MATERIAL_INDEX} />
      },
      {
        path: "/produits/:category/:product",
        element: <MaterialDrawer indexName={algoliaConfig.MATERIAL_INDEX} />
      },
      {
        path: "/productos/:category/:product",
        element: <MaterialDrawer indexName={algoliaConfig.MATERIAL_INDEX} />
      }
    ]
  }
], {
  basename: process.env.NODE_ENV !== 'production' ? "/" : window.steelcase_finish_library.siteUrl.path
});

function renderApp() {
  const rootElement = document.getElementById('fl-root') as HTMLElement;

  if (rootElement) { 
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <RouterProvider router={router} />
    );
  }
}

function loadViaObserver() {
    const targetNode = document.body;
    if(!targetNode) {
        window.setTimeout(loadViaObserver, 500);
        return;
    }
    const config = { childList: true, subtree: true };
    
    const callback = function(mutationsList: any, observer: any) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const addedNodes = Array.from(mutation.addedNodes);
                const rootElement = addedNodes.find((node: any) => node.id === 'fl-root');

                // Special case to render app in PDP
                if (rootElement) {
                    renderApp();
                    observer.disconnect();
                    break;
                }
            }
        }
    };
  
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}
if (document.getElementById('fl-root')) {
    renderApp();
} else {
    loadViaObserver();
}